import React, { useState } from 'react';

import * as S from './styles';
import { ImageInCarrosselScreens } from 'types/ImageInCarrosselScreens';
import Modal from 'components/Modal';
import { generateUid } from 'utils/functions';
import SimpleInput from 'components/SimpleInput';
import InputImgBigger from 'components/InputImgBigger';
import { ImgSavedProps } from 'types/ImgSavedProps';

type FormToAddImgProps = {
	isOpenForm: boolean;
	imgToEdit: ImageInCarrosselScreens | null;
	resetForm: () => void;
	// eslint-disable-next-line no-unused-vars
	excFunctionWhenClicksOnSaveBtn: (img: ImageInCarrosselScreens) => void;
};

const initialImg: ImageInCarrosselScreens = {
	id: generateUid(),
	linkRedirect: '',
	urlImage: '',
	labelImage: ''
};

export default function FormToAddImg({
	imgToEdit,
	isOpenForm,
	resetForm,
	excFunctionWhenClicksOnSaveBtn
}: FormToAddImgProps) {
	const [img, setImg] = useState(imgToEdit === null ? initialImg : imgToEdit);

	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				resetForm();
			}}
			title={imgToEdit === null ? 'Adicionar' : 'Editar'}
			buttonClose={false}
		>
			<S.container>
				<S.twoInputs>
					<SimpleInput
						label="Texto da imagem"
						initialValue={img.labelImage}
						getValue={(value: string) => {
							setImg((obj) => ({
								...obj,
								labelImage: value
							}));
						}}
					/>

					<SimpleInput
						label="Link do redirecionamento"
						initialValue={img.linkRedirect}
						getValue={(value: string) => {
							setImg((obj) => ({
								...obj,
								linkRedirect: value
							}));
						}}
					/>
				</S.twoInputs>

				<InputImgBigger
					idImagem={img.id}
					label="Segunda imagem"
					getImage={(value: ImgSavedProps) => {
						setImg((obj) => ({
							...obj,
							urlImage: value?.url || ''
						}));
					}}
					initialImage={img.urlImage}
				/>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							resetForm();
						}}
					>
						Cancelar
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={() => {
							resetForm();
							excFunctionWhenClicksOnSaveBtn(img);
						}}
					>
						Salvar
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
